import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { Box, Stack } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "react-router-dom";
import { LazyActionChip } from "../Action/ActionChip";

export default function MultiFileSummary({
  link,
  handleOnClick,
  fieldLabel,
  actionRef,
}) {
  const navigate = useNavigate();
  return (
    <ListItemButton
      onClick={() => {
        if (handleOnClick) {
          handleOnClick();
        } else {
          navigate(link);
        }
      }}
      sx={{ border: 1, borderRadius: 1, borderColor: "neutral.200" }}
      disabled={!link && !handleOnClick}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        width={1}
      >
        <Stack>
          <ListItemText primary={fieldLabel} />

          {actionRef && (
            <Box sx={{ my: 0.5 }}>
              <LazyActionChip docRef={actionRef} />
            </Box>
          )}
        </Stack>
        <ListItemIcon sx={{ minWidth: 0 }}>
          <ArrowCircleRightIcon />
        </ListItemIcon>
      </Stack>
    </ListItemButton>
  );
}
